import { createSlice } from "@reduxjs/toolkit";
import {
  AddReportCategoryAction,
  DeleteReportCategoryAction,
  GetAllReportCategoriesAction,
  UpdateReportCategoryAction,
  UpdateDefaultReportCategoryAction,
} from "store/middlewares/dataManagement/category";

export const reportCategoriesSlice = createSlice({
  name: "reportCategory",
  initialState: {
    reportCategoriesLoading: true,
    reportCategories: null,
    reportCategoriesFilterProps: {},
  },
  reducers: {
    setreportCategoriesFilterProps: (state, action) => {
      state.reportCategoriesFilterProps = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllReportCategoriesAction.pending, (state) => {
        // state.reportCategoriesLoading = true;
        state.reportCategories =
          state.reportCategories?.data?.length > 0
            ? state.reportCategories
            : null;
      })
      .addCase(GetAllReportCategoriesAction.fulfilled, (state, action) => {
        state.reportCategoriesLoading = false;
        state.reportCategories = action.payload.response;
      })
      .addCase(GetAllReportCategoriesAction.rejected, (state) => {
        state.reportCategoriesLoading = false;
        state.reportCategories = null;
      })

      // Delete language
      .addCase(DeleteReportCategoryAction.fulfilled, (state, action) => {
        // state.reportCategoriesLoading = false;
        // state.reportCategories = {
        //   ...state.reportCategories,
        //   data: state.reportCategories?.data?.filter(
        //     (item) => item.id !== action.payload.id
        //   ),
        // };
        state.reportCategoriesLoading = false;
        state.reportCategories = action.payload.response;
      })

      //Update language
      .addCase(UpdateReportCategoryAction.fulfilled, (state, action) => {
        // let {
        //   response: { id, ...rest },
        // } = action.payload;
        // let tempArray = state.reportCategories?.map((title) => {
        //   if (title.id === id) {
        //     return { ...title, ...rest };
        //   }
        //   return { ...title };
        // });
        state.reportCategoriesLoading = false;
        state.reportCategories = {
          ...state.reportCategories,
          data: state.reportCategories.data.map((item) =>
            item.id === action.payload.response.id
              ? action.payload.response
              : item,
          ),
        };
      })
      //default
      .addCase(UpdateDefaultReportCategoryAction.fulfilled, (state, action) => {
        state.reportCategoriesLoading = false;
        state.reportCategories = {
          ...state.reportCategories,
          data: state.reportCategories.data.map((reason) =>
            reason.id === action.payload.response.id
              ? { ...reason, ...action.payload.response }
              : { ...reason, is_default: false },
          ),
        };
      })
      //Add language
      .addCase(AddReportCategoryAction.fulfilled, (state, action) => {
        // state.reportCategoriesLoading = false;
        // state.reportCategories = {
        //   ...state.reportCategories,
        //   data: [action.payload.response, ...state.reportCategories.data],
        // };
        state.reportCategoriesLoading = false;
        state.reportCategories = action.payload.response;
      });
  },
});

export const { setreportCategoriesFilterProps } = reportCategoriesSlice.actions;

export default reportCategoriesSlice.reducer;
